module.exports = __webpack_public_path__ + "static/media/18.d10238df.jpg";